<div *ngIf="colOffset" class="row my-2">
  <div [class]="colOffset+' bg-transparent rounded p-3'">
    <ng-content></ng-content>
  </div>
</div>
